import React from 'react';

// Обязательная отметка согласия на обработку ПДн (нативная валидация формы).
const ConsentCheckbox = () => (
  <label className="consent">
    <input type="checkbox" required />
    <span>
      Я даю согласие на обработку персональных данных и принимаю условия{' '}
      <a href="/privacy#consent" target="_blank" rel="noopener noreferrer">Политики конфиденциальности</a>
    </span>
  </label>
);

export default ConsentCheckbox;
